export default function beschriftungUtils(): any {
  const anredeText = (anredeSchluesse: string): string => {
    switch (anredeSchluesse) {
      case "0001":
        return "Frau";
      case "0002":
        return "Herr";
      case "0003":
        return "Firma";
      case "ETG":
        return "Eigen&shy;tümer&shy;gemein&shy;schaft";
      case "WEG":
        return "Wohnungs&shy;eigen&shy;tümer&shy;gemeinschaft";
    }

    return "";
  };

  const deckungssummeText = (dekungssumme: string | number): string => {
    let text;
    if (typeof dekungssumme === "number") {
      text = dekungssumme.toString();
    } else {
      text = dekungssumme;
    }

    switch (text) {
      case "5000000":
        return "5 Mio. €";
      case "10000000":
        return "10 Mio. €";
      case "100":
        return "10 Mio. €";
      case "150":
        return "15 Mio. €";
      case "250":
        return "25 Mio. €";
      case "500":
        return "50 Mio. €";
      default:
        return "";
    }
  };

  const tarifVarianteText = (tarifVariante: string): string => {
    switch (tarifVariante) {
      case "991":
        return "Single";
      case "992":
        return "Single mit Kind(ern)";
      case "993":
        return "Paar";
      case "994":
        return "Familie";
    }
    return "";
  };

  return {
    anredeText,
    deckungssummeText,
    tarifVarianteText,
  };
}
